import React, { useEffect, useMemo } from 'react';
import styles from './UIGameTradeOffers.module.scss';
import clsx from 'clsx';
import { AnimatePresence, motion } from 'framer-motion';
import { UIGameTradeOfferHeader } from './UIGameTradeOfferHeader/index.ts';
import { UIGameTradeOfferActiveOffer } from './UIGameTradeOfferActiveOffer/index.ts';
import { PlayerColor, TradeResponseStatus } from '@colonist/game-states';
import { ModeSettingEnum } from '@colonist/types';
import { TradeValidator } from '@colonist/game-mechanic-validators';
import { useGameStore } from '../../store/GameStoreContext.ts';
import { useIsReplay } from '../../store/selectors/useIsReplay.ts';
import { usePlayerValidators } from '../../store/selectors/usePlayerValidators.ts';
import { useCurrentStateValidator } from '../../store/selectors/useCurrentStateValidator.ts';
export const UIGameTradeOffers = ({ className, disableTooltips })=>{
    const tradeState = useGameStore((state)=>state.gameState.tradeState);
    const myColor = useGameStore((state)=>state.myColor);
    const modeSetting = useGameStore((state)=>state.gameSettings.modeSetting);
    const isReplay = useIsReplay();
    const isTradeOffersVisible = useGameStore((state)=>state.gameTradeOffers.isTradeOffersVisible);
    const setIsTradeOffersVisible = useGameStore((state)=>state.gameTradeOffers.setIsTradeOffersVisible);
    const isGameInBackground = useGameStore((state)=>state.gameClientConfig.isAppInBackground);
    const turnState = useGameStore((state)=>state.gameState.currentState.turnState);
    const isRushMode = modeSetting === ModeSettingEnum.ColonistRush4P;
    const { playerValidators } = usePlayerValidators();
    const currentStateValidator = useCurrentStateValidator();
    const onShowHideTradeClick = ()=>{
        setIsTradeOffersVisible(!isTradeOffersVisible);
    };
    const shouldFilterOutRejectedTradeOffers = isRushMode;
    const activeOffers = useMemo(()=>Object.values(tradeState.activeOffers).filter((offer)=>offer !== undefined).filter((offer)=>{
            if (shouldFilterOutRejectedTradeOffers) {
                const myResponse = offer.playerResponses[myColor];
                if (myResponse === TradeResponseStatus.Rejected) return false;
            }
            return true;
        }).filter((offer)=>{
            var _acceptStatus_errorMessageIfCantTakeAction;
            if (!isRushMode) return true;
            if (myColor == PlayerColor.None) return true;
            if (offer.creator == myColor) return true;
            const tradeValidator = new TradeValidator(offer, currentStateValidator.currentTurnPlayers, playerValidators, tradeState.embargoState);
            const acceptStatus = tradeValidator.getAcceptTradeActionStatus(myColor);
            const cannotAcceptDueToResources = !acceptStatus.canTakeAction && ((_acceptStatus_errorMessageIfCantTakeAction = acceptStatus.errorMessageIfCantTakeAction) === null || _acceptStatus_errorMessageIfCantTakeAction === void 0 ? void 0 : _acceptStatus_errorMessageIfCantTakeAction.key) == 'strings:game.errors.tradeErrors.invalidResources';
            return !cannotAcceptDueToResources;
        }), [
        tradeState,
        myColor,
        isRushMode,
        shouldFilterOutRejectedTradeOffers,
        currentStateValidator.currentTurnPlayers,
        playerValidators
    ]);
    useEffect(()=>{
        if (isRushMode) return;
        setIsTradeOffersVisible(true);
    }, [
        turnState,
        isRushMode
    ]);
    if (activeOffers.length === 0 || isReplay) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.container, className)
    }, /*#__PURE__*/ React.createElement(UIGameTradeOfferHeader, {
        onShowHideTradeClick: onShowHideTradeClick,
        isShowingTrade: isTradeOffersVisible
    }), /*#__PURE__*/ React.createElement(AnimatePresence, null, activeOffers.map((offer)=>/*#__PURE__*/ React.createElement(motion.div, {
            key: offer.id,
            hidden: !isTradeOffersVisible,
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            transition: {
                duration: 0.3
            }
        }, /*#__PURE__*/ React.createElement(UIGameTradeOfferActiveOffer, {
            offer: offer,
            isGameInBackground: isGameInBackground,
            disableTooltips: disableTooltips
        })))));
};
